import { createContext } from "react";

export type StepperContextType = {
  setNextStep: () => Promise<void> | void
  setPreviousStep: () => Promise<void> | void
}

export const StepperContext = createContext<StepperContextType>({
  setNextStep: () => {},
  setPreviousStep: () => {},
});

